"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransaction = void 0;
const core_proto_ts_1 = require("@injectivelabs/core-proto-ts");
const tx_1 = require("@injectivelabs/sdk-ts/dist/cjs/core/modules/tx/utils/tx");
const utils_1 = require("@injectivelabs/utils");
const keccak256_1 = __importDefault(require("keccak256"));
function createTransaction({ chainId, message, timeoutHeight, memo = "", fee = utils_1.DEFAULT_STD_FEE, signMode = 1, pubKey, accountNumber, sequence, }) {
    const signers = {
        pubKey: pubKey,
        accountNumber: accountNumber,
        sequence: sequence,
    };
    const actualSigners = Array.isArray(signers) ? signers : [signers];
    const [signer] = actualSigners;
    const body = (0, tx_1.createBody)({ message, memo, timeoutHeight });
    const feeMessage = (0, tx_1.createFee)({
        fee: fee.amount[0],
        payer: fee.payer,
        granter: fee.granter,
        gasLimit: parseInt(fee.gas, 10),
    });
    const signInfo = (0, tx_1.createSigners)({
        chainId,
        mode: signMode,
        signers: actualSigners,
    });
    const authInfo = (0, tx_1.createAuthInfo)({
        signerInfo: signInfo,
        fee: feeMessage,
    });
    const bodyBytes = core_proto_ts_1.CosmosTxV1Beta1Tx.TxBody.encode(body).finish();
    const authInfoBytes = core_proto_ts_1.CosmosTxV1Beta1Tx.AuthInfo.encode(authInfo).finish();
    const signDoc = (0, tx_1.createSignDoc)({
        chainId,
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        accountNumber: signer.accountNumber,
    });
    const signDocBytes = core_proto_ts_1.CosmosTxV1Beta1Tx.SignDoc.encode(signDoc).finish();
    const toSignBytes = Buffer.from(signDocBytes);
    const toSignHash = (0, keccak256_1.default)(Buffer.from(signDocBytes));
    const txRaw = core_proto_ts_1.CosmosTxV1Beta1Tx.TxRaw.create();
    txRaw.authInfoBytes = authInfoBytes;
    txRaw.bodyBytes = bodyBytes;
    return {
        txRaw,
        signDoc,
        signers,
        signer,
        signBytes: toSignBytes,
        signHashedBytes: toSignHash,
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
    };
}
exports.createTransaction = createTransaction;
//# sourceMappingURL=index.js.map